import axios from 'axios'

export default {
    login: formData => axios.post(`/user/login`, formData)
}
